import { useCoaches, FOUNDER_ID } from "@/hooks/useCoaches";

const cls = "inline-flex items-center rounded-full border border-gold/60 bg-gold/15 px-2 py-0.5 font-serif text-[9px] font-semibold uppercase tracking-[0.18em] text-gold-dark";

export function RoleBadges({ userId }: { userId?: string | null }) {
  const { data } = useCoaches();
  if (!userId) return null;
  const founder = userId === FOUNDER_ID;
  const coach = data?.has(userId);
  if (!founder && !coach) return null;
  return (
    <span className="inline-flex gap-1 align-middle">
      {founder && <span className={cls}>Founder</span>}
      {coach && <span className={cls}>Coach</span>}
    </span>
  );
}
